import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toasts = signal<Toast[]>([]);

  success(message: string, duration = 3500): void {
    this._add('success', message, duration);
  }

  error(message: string, duration = 5000): void {
    this._add('error', message, duration);
  }

  warning(message: string, duration = 4000): void {
    this._add('warning', message, duration);
  }

  remove(id: string): void {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }

  private _add(type: ToastType, message: string, duration: number): void {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    this.toasts.update((list) => [...list, { id, type, message }]);
    setTimeout(() => this.remove(id), duration);
  }
}
